import { render, staticRenderFns } from "./WhatsappHub.vue?vue&type=template&id=3a11470c&scoped=true&"
import script from "./WhatsappHub.vue?vue&type=script&lang=js&"
export * from "./WhatsappHub.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappHub.vue?vue&type=style&index=0&id=3a11470c&lang=scss&scoped=true&"
import style1 from "./WhatsappHub.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a11470c",
  null
  
)

export default component.exports